import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  iconButton: {

    fontWeight: 'bold',
    textTransform: 'capitalize',
    backgroundColor: Colors.blue,
    color: '#FFFFFF',
    minWidth: '12rem',
    transition: 'all 250ms ease-in-out',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
    },
    '&:hover': {
        backgroundColor: Colors.blue,
      opacity: '0.8',
    },
  },


  saveButtonDiv: {
    marginTop: 10,
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row-reverse',
  },

  commentTextArea: {
    borderWidth: 1,
    borderRadius: 5,
    width: '100%',
    minHeight: 100,
    padding: 5,
    resize: 'none',
    backgroundColor: '#F5F5F5',
    marginTop: 30,
  },
  accordionSummary: {
    flexDirection: 'row-reverse',
  },
  accordionDetails: { display: 'flex', alignItems: 'center' },
  commentBaloon: {
    margin: 10,
    padding: 10,
    width: 'fit-content',
    borderRadius: 20,
    backgroundColor: Colors.lightGray,
    display: 'block',
  },
  commentParagraph: {
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all',
  },
}))

export default styles
